<main #trendingContainer class="container-fluid trending-container cinema-section">
    <section #trendingHeader class="d-flex align-items-center flex-row cinema-section-header">
        <div class="cinema-title-shell">
            <div class="d-flex align-items-center cinema-title-group">
                <h3 class="heading-text mb-0 cinema-section-title">{{ languageService.t('castAndCrew') }}</h3>
            </div>
        </div>
    </section>

    <div class="skeleton-container cinema-skeleton" *ngIf="isLoading">
        <div class="trending-movie-container skeleton-card-item" *ngFor="let _ of initialSkeletons">
            <app-card-skeleton [mediaType]="'person'"></app-card-skeleton>
        </div>
    </div>

    <div *ngIf="creditData && creditData.length && !isLoading" class="trending-wrapper">

        <div class="smoke-effect smoke-left" *ngIf="canScrollLeft" [@fadeIn]></div>

        <button 
            class="scroll-btn scroll-btn-left" 
            *ngIf="!isMobile && canScrollLeft"
            (click)="scrollLeft()"
            [@fadeIn]>
            <i class="text-white fa-solid fa-arrow-left"></i>
        </button>
        
        <section #trendingMovieSection class="trending-movie-section" (scroll)="checkScroll()">
            <div *ngFor="let credit of creditData; let i = index" class="trending-movie-container" [@fadeIn]>
                <div #movieCard class="movie-card" >
                    <a [routerLink]="getPersonRoute(credit)">
                        <img class="movie-image" [src]="'https://image.tmdb.org/t/p/w185' + credit.profile_path"
                            [alt]="credit?.name" (error)="onImageError($event)">
                    </a>
                    <div class="content my-2 mx-1">
                        <a [routerLink]="getPersonRoute(credit)"
                           class="movie-name">
                            {{ credit?.name }}
                        </a>
                        <p class="movie-date" *ngIf="credit?.character">
                            {{ credit?.character }}
                        </p>
                        <p class="movie-date" *ngIf="!credit?.character && credit?.job">
                            {{ credit?.job }}
                        </p>
                    </div>
                </div>
            </div>
        </section>
        
        <button 
            class="scroll-btn scroll-btn-right" 
            *ngIf="!isMobile && canScrollRight"
            (click)="scrollRight()"
            [@fadeIn]>
            <i class="text-white fa-solid fa-arrow-right"></i>
        </button>
        
        <div class="smoke-effect smoke-right" *ngIf="canScrollRight" [@fadeIn]></div>
    </div>
</main>
